<template>
  <div id="Login">
    <div class="ldiv">
      <div id="div_top">
      </div>
      <div id="div_center">
        <div id="div_login">
          <div id="div_title" style="color:#ffffff">
            <h1 style="font-size:48px;">HR System</h1>
          </div>
          <div></div>
          <div id="tbl_login"  @keyup.enter="doLogin">
            <div class="input-group" style="display:none">
              <span class="input-group-addon"><span class="glyphicon glyphicon-globe"></span></span>
              <select id="p_lan" class="form-control" v-model="lan">
                <option value="zh">中文</option>
                <option value="en">English</option>
              </select>
            </div>
            <div class="input-group">
              <span class="input-group-addon"><span class="glyphicon glyphicon-user"></span></span>
              <input type="text" id="p_name" :placeholder="rs.loginNameTitle" class="form-control" v-model="name" />
            </div>
            <div class="input-group">
              <span class="input-group-addon"><span class="glyphicon glyphicon-lock "></span></span>
              <input class="form-control" :placeholder="rs.passwordTitle" id="p_pwd" type="password" v-model="pwd" />
            </div>
            <div id="tbnLogin">
              <button class="btn" id="btnLoginx" v-on:click="doLogin">{{rs.loginBtnTitle}}</button>
            </div>
          </div>
        </div>
      </div>
      <div id="div_bottom">
        <div id="div_pwb">
          <span>Powered By Ltd @ 2016 - 2020. All Rights Reserved.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  beforeRouteEnter: function(to, from, next) {
    next(vm => {
      vm.$data.hisPath = from.path;
      //if(!this.$loader) this.$loader = this.$refs.loader.$el
    })
  },
  created: function() {
    this.lan = this.$lan;
  },
  data: function() {
    return {
      name: "",
      pwd: "",
      lan: "zh",
      user: $.userState,
      rs: this.$rs,
      hisPath: "/"
    };
  },
  watch: {
    lan: function(v) {
      if (v == "zh") {
        this.$lan = "zh"
        //this.$extend(this.$rs, $.zhResource);
      } else {
        this.$lan = "en"
        //this.$extend(this.$rs, $.enResource);
      }
        $.fuiLan = this.$lan
    }
  },
  methods: {
    doLogin: function() {
      //if(!this.$loader) this.$loader = this.$refs.loader
      if (this.name === "") {
        this.$alert(this.rs.loginNameMsg);a
      } else if (this.pwd === "") this.$alert(this.rs.passwordMsg);
      else {
        const user = this.xmd;
        this.$showLoader();
        $.ajax({
          type: "post",
          url: this.$apiUrl +"login/Login",
          contentType: "application/json",
          data: JSON.stringify({
            loginName: this.name,
            password: this.pwd,
            lan: this.lan
          }),
          dataType: "json",
          timeout: 30000
        }).then(
          data => {
            if (data.rs) {
              this.user.isLogin = data.rs;
              this.user.name = data.userName;
              this.user.no = data.userNo;
              this.user.menuList = data.menuList;
              window.localStorage.setItem("fui-themes",data.themes)
              //if(this.$trim(this.hisPath)=="/") this.$router.push("welcome")
              //else this.$router.push(this.hisPath)
              document.title = "HR System"
              this.$router.push("welcome")
            } else {
              this.$alert(this.rs.uopMsg);
            }
            this.$hideLoader();
          },
          msg => {
            this.$alert(this.rs.msgSysError);
            this.$hideLoader();
          }
        )
      }
    }
  }
};
</script>

<style scoped>
body,
html,
form {
  height: 99%;
  background-color: #ece9d8;
}

.ldiv {
  width: 100%;
  height: 100%;
}

#div_top {
  position: absolute;
  background-image: url(/static/img/btop.png);
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

#div_center {
  position: absolute;
  background-image: url(/static/img/bg_login1.png);
  left: 0;
  right: 0;
  width: 100%;
  height: 496px;
  top: 40%;
  margin-top: -248px;
  z-index: 3;
}

#div_login {
  position: absolute;
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  background-color: #4d7bb8;
    background: -webkit-radial-gradient(rgb(0, 60, 255),#4d7bb8, #336699); /* Safari 5.1 - 6.0 */
    background: -o-radial-gradient(rgb(0, 60, 255),#4d7bb8, #336699); /* Opera 11.6 - 12.0 */
    background: -moz-radial-gradient(rgb(0, 60, 255),#4d7bb8, #336699); /* Firefox 3.6 - 15 */
  background: radial-gradient(rgb(0, 60, 255),#4d7bb8, #336699);
  /*background-image: url(../static/img/login_main.jpg);*/
  width: 600px;
  height: 350px;
  top: 100px;
  left: 50%;
  margin-left: -300px;
}

#div_bottom {
  position: absolute;
  background-image: url(/static/img/bbottom.png);
  left: 0;
  top: 50%;
  right: 0;
  bottom: 0;
  z-index: 2;
}

#tbl_login {
  position: absolute;
  top: 170px;
  left: 150px;
}

#div_title {
  position: absolute;
  width: 100%;
  top: 80px;
  font-size: 300%;
  font-style: italic;
  font-variant: normal;
  text-align: center;
}

#div_title > img {
  width: 550px;
  margin-left: -50px;
}

#div_pwb {
  position: absolute;
  bottom: 25px;
  left: 50%;
  margin-left: -165px;
  white-space: nowrap;
  color: White;
}

#tbl_login > div {
  margin-top: 7px;
  width: 270px;
}

#tbnLogin{
  margin-left: 80px;
}

#tbnLogin > button {
  text-align: center;
  width: 120px;
}
.form-control {
  height: 30px;
  padding: 2px 5px;
}
</style>
